import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

const initialState = {
  gridSize: null,
  streak: null,
  activePlayer: 'X',
  grid: [],
  gameWinner: null,
  totalTurns: 0,
  myIdentity: {},
  partnerIdentity: {}
};

export const reducer =  function(state = initialState, action) {
  console.log(action.type);
  switch (action.type) {
    case 'INITALIZE_GRID': {
      return {
        ...state,
        grid: action.grid
      }
    }
    case 'PLAY_TURN': {
      return {
        ...state,
        grid: action.grid,
        gameWinner: action.gameWinner,
        activePlayer: action.activePlayer,
        totalTurns: action.totalTurns
      }
    }
    case 'RESET_GRID': {
      return {
        ...initialState,
        myIdentity: state.myIdentity,
        partnerIdentity: state.partnerIdentity,
        grid: action.grid,
        gridSize: action.gridSize,
        streak: action.streak
      }
    }
    case 'REPLACE_STATE': {
      return {
        ...state,
        gridSize: action.gridSize,
        streak: action.streak,
        activePlayer: action.activePlayer,
        grid: action.grid,
        gameWinner: action.gameWinner,
        totalTurns: action.totalTurns
      }
    }
    case 'SET_MY_IDENTITY': {
      return {
        ...state,
        myIdentity: action.value
      }
    }
    case 'SET_PARTNER_IDENTITY': {
      return {
        ...state,
        partnerIdentity: action.value
      }
    }
    default:
      return state;
  }
}

const store = createStore(reducer, applyMiddleware(thunk));
export default store
